import React from 'react';
import PropTypes from 'prop-types';

import './gallery-picture-placeholder.scss';

export function GalleryPicturePlaceholder({ children }) {
  return (
    <div className="gallery-picture-placeholder w-100 rounded mb-1">
      <i className="placeholder-icon icon-camera text-gray size-16" aria-hidden />
      {children}
    </div>
  );
}

GalleryPicturePlaceholder.propTypes = {
  children: PropTypes.node,
};

GalleryPicturePlaceholder.defaultProps = {
  children: null,
};
